import { adminGetPostColumnsSettings, adminGetPostsV2 } from "../util/firebase"
import { useContext, useEffect, useState } from "react"
import useMediaQuery from "@mui/material/useMediaQuery"
import { styled, createTheme } from "@mui/material/styles"
import { firebaseTimeStampToDate, formatLicenseNumber, statuses } from "../util/helpers"
import { createContext } from "react"

import Typography from "@mui/material/Typography"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import TableBody from "@mui/material/TableBody"
import TableHead from "@mui/material/TableHead"
import Link from "@mui/material/Link"
import FilterListIcon from "@mui/icons-material/FilterList"

import scrollTopIcon from "../assets/scrollTopIcon.svg"
import PostStatusFilter from "./PostStatusFilter"
import PostLicenseNumberFilter from "./PostLicenseNumberFilter"
import PostUserIdFilter from "./PostUserIdFilter"
import { AdminContext } from "../views/Admin"
import PostIdFilter from "./PostIdFilter"
import { /* useNavigate, */ useSearchParams } from "react-router-dom"
import { Button, Checkbox, CircularProgress, Pagination, Tooltip } from "@mui/material"
import PostColumnChooser from "./PostColumnChooser"

import * as XLSX from "xlsx"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const postColsDefaults = [
	{ label: "מזהה", field: "id", type: "text", display: false },
	{ label: "מודעה", field: "licenseNumber", type: "license", display: true },
	{ label: "משתמש", field: "userId", type: "userid", display: true },
	{ label: "טלפון", field: "phoneNumber", type: "text", display: true },
	{ label: "ת. יצירה", field: "createDateTime", type: "datetime", display: true },
	{ label: "ת. פרסום", field: "publishDateTime", type: "datetime", display: false },
	{ label: "סטטוס", field: "status", type: "status", display: true },
	{ label: "יצרן", field: "make", type: "text", display: true },
	{ label: "דגם", field: "model", type: "text", display: true },
	{ label: "שנה", field: "year", type: "text", display: false },
	{ label: "מחיר מינימום", field: "reservePrice", type: "currency", display: false },
	{ label: "מחיר רכישה מיידית", field: "buyNowPrice", type: "currency", display: true },
	{ label: "תחילת מכירה", field: "startDateTime", type: "datetime", display: false },

	{ label: "מיקום הרכב", field: "area", type: "text", display: false },
	{ label: "מכירה פומבת פעילה", field: "auctionEnabled", type: "boolean", display: false },
	//{ label: "תחילת מכירה פומבית", field: "auctionStartDateTime", type: "datetime", display: false },
	{ label: "תיאור מלכת הכביש", field: "bloggerDescription", type: "text", display: false },
	{ label: "מרכב", field: "bodyType", type: "text", display: false },
	{ label: "צבע", field: "color", type: "text", display: false },
	{ label: "תיאור", field: "description", type: "text", display: false },
	{ label: "הנעה", field: "driveTrain", type: "text", display: false },
	{ label: "תאירך סיום", field: "endDateTime", type: "datetime", display: false },
	{ label: "סוג מנוע", field: "engineType", type: "text", display: false },
	{ label: "נפח מנוע", field: "engineVolume", type: "text", display: false },
	{ label: "אפשרות מימון", field: "financingAvailable", type: "boolean", display: false },
	{ label: "תאריך עלייה לכביש", field: "firstRegistration", type: "datetime", display: false },
	{ label: "גודל גלגל קדמי", field: "frontWheelSize", type: "text", display: false },
	{ label: "סוג דלק", field: "fuelType", type: "text", display: false },
	{ label: "כוח סוס", field: "horsePower", type: "text", display: false },
	{ label: "הערות מנהלן", field: "internalComments", type: "text", display: false },
	{ label: "תאריך רענון אחרון", field: "lastDataRefresh", type: "datetime", display: false },
	{ label: "מספר כריות אוויר", field: "noOfAirBags", type: "text", display: false },
	{ label: "מספר דלתות", field: "noOfDoors", type: "text", display: false },
	{ label: "מספר חלונות חשמל", field: "noOfPowerWindows", type: "text", display: false },
	{ label: "מספר מושבים", field: "noOfSeats", type: "text", display: false },
	{ label: "קילומטרז׳", field: "odometer", type: "text", display: false },
	{ label: "בעלות", field: "ownership", type: "text", display: false },
	{ label: "דרגת זיהום אוויר", field: "pollutionLevel", type: "text", display: false },
	{ label: "משך פרסום המודעה", field: "postDuration", type: "text", display: false },
	{ label: "סוג הנעה", field: "powerTrain", type: "text", display: false },
	{ label: "יד", field: "previousOwners", type: "text", display: false },
	{ label: "דירוג מחיר", field: "priceScore", type: "text", display: false },
	{ label: "דירוג טווח עליון", field: "priceScoreMax", type: "currency", display: false },
	{ label: "דירוג טווח תחתון", field: "priceScoreMin", type: "currency", display: false },
	{ label: "גודל גלגל אחורי", field: "rearWheelSize", type: "text", display: false },
	{ label: "תוקף טסט", field: "registrationExpiryDate", type: "datetime", display: false },
	{ label: "דירוג בטיחות", field: "safteyScore", type: "text", display: false },
	{ label: "תגיות", field: "tags", type: "array", display: false },
	{ label: "אפשרות לטרייד אין", field: "tradeInAvailable", type: "boolean", display: false },
	{ label: "הילוכים", field: "transMission", type: "text", display: false },
	{ label: "רמת גימור", field: "trimLevel", type: "text", display: false },
	{ label: "מספר שלדה", field: "vin", type: "text", display: false },
]

export const PostAdminContext = createContext(null)

const Posts = ({ containerRef }) => {
	const adminContext = useContext(AdminContext)
	const handleUserDialogOpen = adminContext.handleUserDialogOpen
	const handlePostOptionOpen = adminContext.handlePostOptionOpen

	const [loading, setLoading] = useState(true)
	const [postCols, setPostCols] = useState(postColsDefaults)

	const [page, setPage] = useState(1)
	const [pageCount, setPageCount] = useState(1)
	const [noOfPosts, setNoOfPosts] = useState(0)

	const [posts, setPosts] = useState([])

	const [sort, setSort] = useState({})

	const [postColumnChooserOpen, setPostColumnChooserOpen] = useState(false)

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	//const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	//const filter = searchParams.get("filter") ?? "PENDINGREVIEW"
	const filter = searchParams.get("filter") ?? ""
	//const [statusFilter, setStatusFilter] = useState(filter)
	/* const handlePostOptionOpen = async (index) => {
		setPost(posts[index])
		setPostOptionsOpen(true)
	} */

	const downloadToExcel = () => {
		const workSheetName = `Bullcar Posts ${new Date().toLocaleDateString("he")}`

		const wsData = []
		wsData.push(postCols.filter((col) => col.display === true).map((e) => e.label))
		posts.forEach((post, index) => {
			const tmpArray = postCols
				.filter((col) => col.display === true)
				.map((e) => {
					//return post[e.field]
					return renderPostValue(e.type, post[e.field], index, true)
				})
			wsData.push(tmpArray)
		})

		var ws = XLSX.utils.aoa_to_sheet(wsData)

		/* Create workbook */
		var wb = XLSX.utils.book_new()

		/* Add the worksheet to the workbook */
		XLSX.utils.book_append_sheet(wb, ws, workSheetName)

		/* Write to file */
		XLSX.writeFile(wb, `Bullcar Posts ${new Date().toLocaleDateString("he")}.xlsx`)
	}

	const topFunction = () => {
		console.log(containerRef.current)
		containerRef.current.scroll(0, 0) // For Safari
		//document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	const getPosts = async () => {
		setLoading(true)
		const response = await adminGetPostsV2({ sort: sort, status: filter })
		setLoading(false)
		if (response.data.status === 0) {
			setPosts(response.data.posts)
			setPageCount(response.data.noOfPages)
			setNoOfPosts(response.data.noOfPosts)
		}
	}

	const handleStatusFilter = (e) => {
		//setStatusFilter(e.target.value)
		//navigate("/?tab=posts&filter=" + e.target.value)
		window.location.href = "/?tab=posts&filter=" + e.target.value
	}

	useEffect(() => {
		if (filter.length === 0 && Object.keys(sort).length === 0 && posts.length === 0 && page === 1) {
			getPosts()
		} else if (filter.length > 0 || Object.keys(sort).length > 0) {
			setPage(1)
			getPosts()
		}
		//getPosts()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sort, filter])

	useEffect(() => {
		const _adminGetPostColumnsSettings = async () => {
			const response = await adminGetPostColumnsSettings()
			if (response.data.adminPostColumnSettings) {
				setPostCols(response.data.adminPostColumnSettings)
			}
		}

		_adminGetPostColumnsSettings()
	}, [])

	const handleLicenseNumberFilter = (value) => {
		const _value = value?.id?.replace("-", "")
		if (_value?.length > 0) {
			setPage(1)
			setPosts((prevState) => prevState.filter((element) => element.licenseNumber.indexOf(_value) > -1))
		} else {
			setPage(1)
			getPosts()
		}
	}

	const handleIdFilter = (value) => {
		if (value?.length > 0) {
			setPage(1)
			setPosts((prevState) => prevState.filter((element) => element.id.indexOf(value) > -1))
		} else {
			setPage(1)
			getPosts()
		}
	}

	const handleUserIdFilter = (value) => {
		const _value = value?.id
		if (_value?.length > 0) {
			setPage(1)
			setPosts((prevState) => prevState.filter((element) => element.userId.indexOf(_value) > -1))
		} else {
			setPage(1)
			getPosts()
		}
	}

	const handleSort = (field) => {
		setSort((prevState) =>
			prevState.field === field ? { field: field, asc: !prevState.asc } : { field: field, asc: true }
		)
	}

	const handleChange = async (event, value) => {
		//setPage(value)
		if (value === page + 1 && posts.length < value * 100) {
			console.log(posts[posts.length - 1].id)
			setLoading(true)
			const response = await adminGetPostsV2({ sort: sort, status: filter, startAfter: posts[posts.length - 1].id })
			setLoading(false)
			if (response.data.status === 0) {
				setPosts((prevState) => [...prevState, ...response.data.posts])
				//setPosts(response.data.posts)
				setPageCount(response.data.noOfPages)
			}
		}
		if (posts.length >= (value - 1) * 100 || posts.length === noOfPosts) setPage(value)
	}

	const renderPostValue = (type, value, index, textOnly = false) => {
		let _internalComments
		if (posts[index].internalComments) {
			_internalComments = posts[index].internalComments.replaceAll("\n", "<br/>")
		} else {
			_internalComments = posts[index].internalComments
		}

		switch (type) {
			case "text":
				return value
			case "datetime":
				return firebaseTimeStampToDate(value)?.toLocaleString("he")
			case "license":
				if (textOnly) {
					return formatLicenseNumber(value)
				} else {
					return (
						<Tooltip title={<span dangerouslySetInnerHTML={{ __html: _internalComments }} />}>
							<Link
								target="_blank"
								sx={{ cursor: "pointer" }}
								onClick={() => handlePostOptionOpen(posts[index].id, posts[index].status)}
							>
								{formatLicenseNumber(value)}
							</Link>
						</Tooltip>
					)
				}
			case "currency":
				return "\u20aa" + new Intl.NumberFormat().format(parseInt(value))
			case "status":
				return statuses[value] ?? value
			case "userid":
				if (textOnly) {
					return value
				} else {
					return (
						<Link target="_blank" sx={{ cursor: "pointer" }} onClick={() => handleUserDialogOpen(value)}>
							{value}
						</Link>
					)
				}
			case "boolean":
				if (textOnly) {
					return value ? "כן" : "לא"
				} else {
					return <Checkbox checked={value} disabled />
				}
			case "array":
				return value.toString()
			default:
				return value
		}
	}

	const contextObject = {
		filter: filter,
		handleStatusFilter: handleStatusFilter,
		handleLicenseNumberFilter: handleLicenseNumberFilter,
		posts: posts,
		handleUserIdFilter: handleUserIdFilter,
		handleIdFilter: handleIdFilter,
		/* postOptionsOpen: postOptionsOpen,
		handlePostOptionsClose: handlePostOptionsClose,
		post: post, */
		/* refreshPost: refreshPost, */
	}

	return (
		<PostAdminContext.Provider value={contextObject}>
			<PostColumnChooser
				postColumnChooserOpen={postColumnChooserOpen}
				setPostColumnChooserOpen={setPostColumnChooserOpen}
				postCols={postCols}
				setPostCols={setPostCols}
			/>
			{matches ? (
				<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
					<Typography variant="h6">סינון:</Typography>
					<PostStatusFilter maxWidth={"200px"} />
					<PostLicenseNumberFilter maxWidth={"400px"} />
					<PostUserIdFilter maxWidth={"400px"} />
					<PostIdFilter maxWidth={"400px"} />
					<div>
						<Button
							sx={{ backgroundColor: mdTheme.palette.primary.main, width: matches ? "120px" : "auto", mr: 2 }}
							onClick={() => setPostColumnChooserOpen(true)}
							variant="contained"
						>
							בחירת עמודות
						</Button>
						<Button
							sx={{ backgroundColor: mdTheme.palette.secondary.main, width: matches ? "120px" : "auto" }}
							onClick={() => downloadToExcel()}
							variant="contained"
						>
							ייצוא לאקסל
						</Button>
					</div>
					{loading ? (
						<Paper
							sx={{
								p: 2,
								display: "flex",
								flexDirection: "column",
								height: 100,
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<CircularProgress />
						</Paper>
					) : (
						<Table
							sx={{
								tableLayout: "fixed",
								/* "th:nth-of-type(1), td:nth-of-type(1)": { width: "180px" },
								"th:nth-of-type(2), td:nth-of-type(2)": { width: "280px" }, */
							}}
							aria-label="simple table"
						>
							<TableHead>
								<TableRow>
									{postCols.map((col) => {
										if (col.display) {
											return (
												<TableCell
													key={col.field}
													variant="head"
													sx={{ fontWeight: 600, cursor: "pointer" }}
													onClick={() => handleSort(col.field)}
												>
													<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
														{col.label}
														{sort.field === col.field ? (
															sort.asc ? (
																<FilterListIcon />
															) : (
																<FilterListIcon sx={{ transform: "rotate(180deg)" }} />
															)
														) : null}
													</div>
												</TableCell>
											)
										} else {
											return null
										}
									})}
								</TableRow>
							</TableHead>
							<TableBody>
								{posts
									.filter((e, i) => i >= (page - 1) * 100 && i < page * 100)
									.map((post, index) => (
										<TableRow key={post.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
											{postCols.map((col) => {
												if (col.display) {
													return (
														<TableCell
															/* align={col.field === "licenseNumber" ? "center" : "left"} */
															sx={{ wordWrap: "break-word" }}
															key={col.field}
														>
															{renderPostValue(col.type, post[col.field], index)}
														</TableCell>
													)
												} else {
													return null
												}
											})}
										</TableRow>
									))}
							</TableBody>
						</Table>
					)}
				</Paper>
			) : (
				<>
					<ScrollTopButton onClick={() => topFunction()}>
						<img style={{ width: "20px", height: "20px" }} src={scrollTopIcon} alt="Scroll To Top" />
					</ScrollTopButton>
					<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
						<Typography variant="h6">סינון:</Typography>
						<PostStatusFilter />
						<Typography variant="h6">חיפוש מודעה:</Typography>
						<PostIdFilter />
						<PostLicenseNumberFilter />
						<PostUserIdFilter />
						<Button
							sx={{ backgroundColor: mdTheme.palette.primary.main, width: matches ? "120px" : "auto", mb: 2 }}
							onClick={() => setPostColumnChooserOpen(true)}
							variant="contained"
						>
							בחירת עמודות
						</Button>
						<Button
							sx={{ backgroundColor: mdTheme.palette.secondary.main, width: matches ? "120px" : "auto" }}
							onClick={() => downloadToExcel()}
							variant="contained"
						>
							ייצוא לאקסל
						</Button>
					</Paper>
					{posts
						.filter((e, i) => i >= (page - 1) * 100 && i < page * 100)
						.map((post, index) => (
							<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }} key={post.id}>
								{loading ? (
									<Paper
										sx={{
											p: 2,
											display: "flex",
											flexDirection: "column",
											height: 100,
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<CircularProgress />
									</Paper>
								) : (
									<Table sx={{ tableLayout: "fixed" }}>
										<TableBody>
											{postCols.map((col) => {
												if (col.display) {
													return (
														<TableRow key={col.field}>
															<TableCell variant="head" sx={{ fontWeight: 600 }}>
																{col.label}
															</TableCell>
															<TableCell sx={{ wordWrap: "break-word" }}>
																{renderPostValue(col.type, post[col.field], index)}
															</TableCell>
														</TableRow>
													)
												} else {
													return null
												}
											})}
										</TableBody>
									</Table>
								)}
							</Paper>
						))}
				</>
			)}
			<Pagination count={pageCount} page={page} onChange={handleChange} size={matches ? "medium" : "small"} />
		</PostAdminContext.Provider>
	)
}

export const ScrollTopButton = styled("button")({
	display: "block" /* Hidden by default */,
	position: "fixed" /* Fixed/sticky position */,
	bottom: "20px" /* Place the button at the bottom of the page */,
	right: "30px" /* Place the button 30px from the right */,
	zIndex: "99" /* Make sure it does not overlap */,
	border: "1px solid #555" /* Remove borders */,
	outline: "none" /* Remove outline */,
	backgroundColor: "white" /* Set a background color */,
	color: "white" /* Text color */,
	cursor: "pointer" /* Add a mouse pointer on hover */,
	padding: "5px" /* Some padding */,
	borderRadius: "10px" /* Rounded corners */,
})

export default Posts
